import React, { useState } from 'react';
import { AlertTriangle, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { apiFetch } from '../../services/api';

const API = process.env.REACT_APP_BACKEND_URL;

export const LicenseLowBanner = ({ seats }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const total = seats?.seats_total || 0;
  const free = seats?.seats_free ?? Math.max(total - (seats?.seats_used || 0), 0);
  if (total === 0 || free !== 1) return null;

  const goUpgrade = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch(`${API}/api/digistore/license-upgrade?add=1`);
      const data = await res.json();
      if (!res.ok || !data.checkout_url) throw new Error(data.detail || 'Upgrade-Link nicht verfügbar');
      sessionStorage.setItem('sv_license_expected', String(data.new_total));
      window.location.href = data.checkout_url;
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  return (
    <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3" data-testid="license-low-banner">
      <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0" />
      <p className="flex-1 text-sm text-amber-100" data-testid="license-low-text">
        <strong>Nur noch 1 freie Lizenz verfügbar</strong> – Jetzt weitere Lizenzen unkompliziert hinzubuchen.
        {error && <span className="block text-red-300 mt-1" data-testid="license-low-error">{error}</span>}
      </p>
      <Button onClick={goUpgrade} disabled={loading} size="sm" className="bg-amber-500 hover:bg-amber-400 text-black font-bold shrink-0" data-testid="license-low-upgrade-btn">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Lizenz hinzubuchen <ArrowRight className="w-4 h-4 ml-1" /></>}
      </Button>
    </div>
  );
};

export default LicenseLowBanner;
